define('attachmentsView',[
  'module',
  'backbone',
  'marionette',
  'underscore',
  'dropzone',
  'settings',
  'attachmentView',
  'imageEditorView',
  'vectorEditorView',
  'template!attachmentsView'
], function(
  Module,
  Backbone,
  Marionette,
  _,
  Dropzone,
  Settings,
  AttachmentView,
  ImageEditorView,
  VectorEditorView,
  Tpl
) {
  'use strict';
  
  Module.exports = Marionette.CompositeView.extend({
    template: Tpl,
    childView: AttachmentView,    
    childViewContainer: '.attachments-container',
    className: 'attachments-view',   
    pageSize: 10,
    first: 0,   

    childViewOptions: function() {
      return {
        config: this.config
      };
    },

    initialize: function () {
      this.config = _.extend({
        canEdit: true,
        canDelete: true,
        canDownload: true,
        canCopy: true,
        canZoom: true,
        canFlag: false,
        canEditRaster: true,
        canEditVector: true,
        canApplyToComposition: false
      }, this.setConfig());

      // The raster image editor and the "apply to personalisation" action are
      // power-user features — only surface them when advancedMode is on,
      // regardless of what the subclass requested via setConfig().
      if (!Settings.configValue('advancedMode')) {
        this.config.canEditRaster = false;
        this.config.canEditVector = false;
        this.config.canApplyToComposition = false;
      }

      this.collection = new Backbone.Collection();

      this.attachmentsToUload = [];
      this.uploadTimer = null;
    },

    setConfig: function() { return {}; },   

    childEvents: {
      'edit': function(view) { 
        if(this.editItem)
          return this.editItem(view.model.get('attachment'));
      },
      'delete': function(view) { 
        if(this.deleteItem)
          return this.deleteItem(view.model.get('attachment')).done(_.bind(function() {
            this.collection.remove(view.model);
          }, this));
      },     
      'download': function(view) { 
        if(this.downloadItem)
          return this.downloadItem(view.model.get('attachment'));
      },
      'copy': function(view) {
        if(this.copyItem)
          return this.copyItem(view.model.get('attachment'));
      },
      'edit-raster': function(view) {
        return this.openRasterEditor(view.model.get('attachment'));
      },
      'edit-vector': function(view) {
        return this.openVectorEditor(view.model.get('attachment'));
      },
      'apply-composition': function(view) {
        if(this.applyItemToComposition)
          return this.applyItemToComposition(view.model.get('attachment'));
      },
      'ai-edit': function(view) {
        if(this.aiEditItem)
          return this.aiEditItem(view.model.get('attachment'));
      }
    },

    ui: {   
      dropZone: '.drop-zone',
      dropZoneIcon: '.drop-zone svg',
      attachmentsContainer: 'attachments-container'
    },

    events: {  
      'click @ui.dropZoneIcon': function () { this.ui.dropZone.click(); }
    },  

    onShow: function() {
    
      this.observer = new window.IntersectionObserver(_.bind(function(aEntries) {
        if(aEntries.length > 0 && aEntries[0].isIntersecting)         
          this._fetch();          
      }, this), {
        root: this.ui.attachmentsContainer[0],
        rootMargin: '30px',
        threshold: 0.5
      });    

      this._fetch(); 
    },

    onRender: function() {
      var that = this;

      this.ui.dropZone.dropzone({
        url: Settings.url('compuzz'),
        autoProcessQueue: true,
        uploadMultiple: true,

        init: function () {          
          this.on('addedfile', function(file) {

            var attachmentToUpload = new Backbone.Model({
                file: file,
                fileName: file.name,
                attachment: null,
                uploading: true,
                error: false
            });

            that.collection.add(attachmentToUpload);
            that.attachmentsToUload.push(attachmentToUpload);

            if(that.uploadTimer)
                clearTimeout(that.uploadTimer);

            that.uploadTimer = setTimeout(function () {
              that.uploadAll();
            }, 1000);

            this.removeAllFiles();
          });        
        },
        dictDefaultMessage: _.i18n('common.file.drag.drop')
      });
    },

    uploadAll: function() {
      if(this.uploadItem) {
        var promiseList = [];

        _.each(this.attachmentsToUload, _.bind(function (attachmentToUload) {
          promiseList.push(_.bind(function () {
            return new Promise(_.bind(function(resolve) {
              this.uploadItem(attachmentToUload.get('file')).done(_.bind(function (attachment) {
                attachmentToUload.set('uploading', false);
                attachmentToUload.set('error', false);
                attachmentToUload.set('attachment', attachment);
                this.attachmentsToUload = [];
                resolve();
              }, this)).fail(_.bind(function () {
                attachmentToUload.set('uploading', false);
                attachmentToUload.set('error', true);
                this.attachmentsToUload = [];
                resolve();
              }, this));
            }, this));
          }, this));
        }, this));

        promiseList.reduce(function (previousPromise, currentFunction) {
          return previousPromise.then(currentFunction);
        }, Promise.resolve());
      }
    },
    
    _fetch: function() {

      if(!this.fetch)
        return;

      this.observer.disconnect(); 

      this.fetch(this.first, this.pageSize)
      .done(_.bind(function (items) {

        _.each(items, _.bind(function(attachment) {
          var model = new Backbone.Model({
            file: null,
            fileName: attachment.get('fileName'),
            attachment: attachment
          });
          if(!this.collection.findWhere({id: attachment.get('id')}))
            this.collection.add(model);
        }, this));        
        
        this.first = this.collection.length;

        if(items.length > 0) {
          var view = this.children.last();  
        
          if(view)
            this.observer.observe(view.$el[0]);
        } 
      }, this)); 
    },
    
    // Opens the file-editing AI chat popup on an attachment — shared by the
    // order/customer Attachments and Documents tabs (config canAiEdit +
    // aiEditItem). Reloads the gallery on close: an applied AI edit swaps
    // the attachment's file.
    openAiEditChat: function(poi, attachment) {
      var self = this;
      var options = {
        attachmentSession: {
          poi: poi,
          fileUid: attachment.get('fileUid'),
          fileName: attachment.get('fileName'),
          // preview link of the CURRENT file, shown above the chat thread
          fileLink: attachment.get('fileLink')
        }
      };
      require(['windows', 'ordersDetailAiChatView'], function(Windows, AiChatView) {
        Windows.open({
          view: function () { return new AiChatView(options); },
          id: 'ai-attachment-chat:' + attachment.get('fileUid'),
          title: _.i18n('attachments.aiEdit', null, 'Edit with AI') + ': ' + attachment.get('fileName'),
          modal: true,
          bodyClass: 'ai-attachment-chat-body',
          width: '70%',
          height: '85%',
          onClose: function() { self.refresh(); }
        });
      });
    },

    // Full reload of the list from page 0. Needed after an external change
    // of an EXISTING attachment (e.g. the AI file-editing chat replaced its
    // file): the incremental fetch dedupes by row id, so without a reset the
    // stale thumbnail would survive a refetch.
    refresh: function() {
      if (this.isDestroyed) { return; }
      this.collection.reset();
      this.first = 0;
      this._fetch();
    },

    addAttachment: function(attachment) {
      var model = new Backbone.Model({
        file: null,
        fileName: attachment.get('fileName'),
        attachment: attachment
      });
      this.collection.add(model, {at: 0});
    },

    openRasterEditor: function(attachment) {
      if(!attachment || !this.uploadItem)
        return;

      var fileLink = attachment.get('fileLink');
      if(!fileLink)
        return;

      // Strip any `action=` query param so we edit the original file, not a thumbnail / resized variant.
      var url = Settings.url('base', fileLink.replace(/([?&])action=[^&]*&?/, '$1').replace(/[?&]$/, ''));

      ImageEditorView.open({
        id: attachment.get('secId') || attachment.get('id'),
        url: url,
        fileName: attachment.get('fileName'),
        title: _.i18n('imageEditor.title', null, 'Image editor') + ': ' + attachment.get('fileName'),
        onSave: _.bind(function(file) {
          this._uploadEditedFile(file);
        }, this)
      });
    },

    // Print areas of the order (mm), offered by the vector editor as artboard sizes.
    // Order / customer attachment views override getPrintAreas().
    getPrintAreas: function() {
      return [];
    },

    printAreasFromOrder: function(order) {
      var list = [], seen = {};
      if(!order || !order.get)
        return list;

      _.each(order.get('compositions') || [], function(c) {
        var paLabel = c.paName || c.paCode || '';
        _.each(c.availablePzs || [], function(pz) {
          var w = parseFloat(pz.width), h = parseFloat(pz.height), key, current = pz.id === c.pzId;
          if(isNaN(w) || isNaN(h) || w <= 0 || h <= 0)
            return;
          key = paLabel + '|' + (pz.id || pz.name) + '|' + w + 'x' + h;
          if(seen[key])
            return;
          seen[key] = true;
          list.push({
            width: w,
            height: h,
            current: current,
            label: (current ? '\u2605 ' : '') + (paLabel ? paLabel + ' \u00b7 ' : '') + (pz.name || pz.imppCode || '') +
              ' \u2014 ' + w + ' \u00d7 ' + h + ' mm'
          });
        });
      });

      // the print zones that are in use first
      return _.sortBy(list, function(pa) { return pa.current ? 0 : 1; });
    },

    openVectorEditor: function(attachment) {
      if(!attachment || !this.uploadItem)
        return;

      var fileLink = attachment.get('fileLink');
      if(!fileLink)
        return;

      var url = Settings.url('base', fileLink.replace(/([?&])action=[^&]*&?/, '$1').replace(/[?&]$/, ''));

      VectorEditorView.open({
        id: attachment.get('secId') || attachment.get('id'),
        url: url,
        fileName: attachment.get('fileName'),
        printAreas: this.getPrintAreas(),
        title: _.i18n('vectorEditor.title', null, 'Vector editor') + ': ' + attachment.get('fileName'),
        onSave: _.bind(function(file) {
          this._uploadEditedFile(file);
        }, this)
      });
    },

    _uploadEditedFile: function(file) {
      var attachmentToUpload = new Backbone.Model({
        file: file,
        fileName: file.name,
        attachment: null,
        uploading: true,
        error: false
      });

      this.collection.add(attachmentToUpload, {at: 0});

      this.uploadItem(file).done(_.bind(function(attachment) {
        attachmentToUpload.set('uploading', false);
        attachmentToUpload.set('error', false);
        attachmentToUpload.set('attachment', attachment);
      }, this)).fail(_.bind(function() {
        attachmentToUpload.set('uploading', false);
        attachmentToUpload.set('error', true);
      }, this));
    }
  });
});

